import { getMode } from './utils';

export const READONLY_MODES = ['readonly', 'feedback', 'preview', 'basic-viewer'];

export function isReadonly() {
  const mode = getMode();
  return READONLY_MODES.includes(mode);
}
